// import * as fs from "fs";
import { FileManagerOnline } from "./FileManager";
let fs;
const fileManagerOnline = new FileManagerOnline();
export default class FileLoaderBrowser {
	LoadFile(FileName, bIsCryptoFile) {
		try { 
			const res = (window.isPreview) ? localStorage.getItem(FileName): fileManagerOnline.readFileSync(FileName);
			localStorage.setItem(FileName, res);
			// return fs.readFileSync(FileName);
			// return this.readFileSync(FileName);
			return res;
		} catch {
			return localStorage.getItem(FileName);
		}
	}
	FileExist(FileName, bIsCryptoFile) {
		return fs.existsSync(FileName);
	}
	getAbsolutePath(FileName) {
		return FileName;
	}
	getIncludeFilePath(sPath, bIsCryptoFile) {
		throw new Error("Method not implemented.");
	}
}

//# sourceMappingURL=FileLoaderBrowser.js.map
